<!--
 * @Descripttion: 类目管理页面
 * @version: 
 * @Author: Raoxf
 * @Date: 2024-01-01 00:00:00
 * @LastEditors: Raoxf
 * @LastEditTime: 2024-01-01 00:00:00
-->
<template>
  <div class="page-container">
    <!-- 类目tabs -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane
          v-for="(tab, index) in categoryTabs"
          :key="tab.id"
          :label="tab.name"
          :name="index.toString()"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <div class="search-box">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <el-form-item>
          <el-button type="success" size="small" @click="addCategory"
            >新增类目</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="success"
            size="small"
            @click="editCategory(categoryTabs[activeTab])"
            >编辑</el-button
          >
        </el-form-item> -->
      </el-form>
    </div>

    <div class="table-container">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column prop="id" label="类目ID" width="100"></el-table-column>
        <el-table-column
          prop="name"
          label="类目名称"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="description"
          label="类目描述"
          min-width="200"
        ></el-table-column>
        <el-table-column prop="bannerImage" label="横幅图片" width="120">
          <template slot-scope="scope">
            <img
              v-if="scope.row.bannerImage"
              :src="scope.row.bannerImage"
              style="width: 60px; height: 40px; object-fit: cover"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editCategory(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteCategory(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑类目对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      @close="resetForm"
    >
      <el-form
        ref="categoryForm"
        :model="categoryForm"
        :rules="categoryRules"
        label-width="100px"
      >
        <el-form-item label="类目名称" prop="name">
          <el-input
            v-model="categoryForm.name"
            placeholder="请输入类目名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="类目描述" prop="description">
          <el-input
            v-model="categoryForm.description"
            type="textarea"
            :rows="3"
            placeholder="请输入类目描述"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="横幅图片" prop="bannerImage">
          <el-upload
            class="form-upload"
            ref="uploadBanner"
            action="#"
            name="bannerUrl"
            accept=".png, .jpg, .gif, .GIF"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleBannerUpload"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上传图片</el-button
            >
          </el-upload>
          <div
            v-if="categoryForm.bannerImage"
            style="margin-top: 10px; position: relative; display: inline-block"
          >
            <img
              :src="formatImageUrl(categoryForm.bannerImage)"
              style="
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 4px;
              "
            />
            <img
              @click="deleteBannerImage"
              src="../../assets/delete.png"
              style="
                height: 20px;
                width: 20px;
                position: absolute;
                top: 5px;
                right: 5px;
                cursor: pointer;
                background: rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                padding: 2px;
              "
            />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CategoryList",
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeTab: "0", // 当前激活的tab
      categoryTabs: [], // 一级类目tabs
      searchData: {
        categoryName: "",
      },
      dialogVisible: false,
      dialogTitle: "新增类目",
      categoryForm: {
        id: null,
        parentId: "",
        name: "",
        description: "",
        bannerImage: "",
      },
      categoryRules: {
        name: [{ required: true, message: "请输入类目名称", trigger: "blur" }],
        description: [
          { required: true, message: "请输入类目描述", trigger: "blur" },
        ],
        bannerImage: [
          { required: true, message: "请上传横幅图片", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    // 获取类目列表
    async getCategoryList() {
      this.loading = true;
      try {
        const data = await this.$get("/housekeepingCategory/list");
        console.log("data", data);
        this.categoryTabs = data || [];
        // 默认显示第一个tab的子类目
        if (this.categoryTabs.length > 0) {
          this.tableData = this.categoryTabs[0].childrenList || [];
          this.total = this.tableData.length;
        }
      } catch (error) {
        this.$message.error("获取类目列表失败");
      } finally {
        this.loading = false;
      }
    },
    // tab切换
    handleTabClick(tab) {
      const tabIndex = parseInt(tab.name);
      this.activeTab = tab.name;
      // 显示对应tab的子类目
      if (this.categoryTabs[tabIndex]) {
        this.tableData = this.categoryTabs[tabIndex].childrenList || [];
        this.total = this.tableData.length;
      }
    },
    // 搜索
    search() {
      this.currentPage = 1;
      this.filterTableData();
    },
    // 重置
    reset() {
      this.searchData = {
        categoryName: "",
      };
      this.currentPage = 1;
      this.filterTableData();
    },
    // 过滤表格数据
    filterTableData() {
      const tabIndex = parseInt(this.activeTab);
      if (this.categoryTabs[tabIndex]) {
        this.tableData = this.categoryTabs[tabIndex].childrenList || [];
        this.total = this.tableData.length;
      }
    },
    // 新增类目
    addCategory() {
      this.dialogTitle = "新增类目";
      const tabIndex = parseInt(this.activeTab);
      this.categoryForm = {
        id: null,
        parentId: this.categoryTabs[tabIndex]
          ? this.categoryTabs[tabIndex].id
          : "",
        name: "",
        description: "",
        bannerImage: "",
      };
      this.dialogVisible = true;
    },
    // 编辑类目
    editCategory(row) {
      this.dialogTitle = "编辑类目";
      this.categoryForm = {
        id: row.id,
        parentId: row.parentId || "",
        name: row.name,
        description: row.description,
        bannerImage: row.bannerImage || "",
      };
      this.dialogVisible = true;
    },
    // 删除类目
    deleteCategory(row) {
      this.$confirm("确认删除该类目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await this.$post("/housekeepingCategory/delete", { id: row.id });
            this.$message.success("删除成功");
            // 保存当前tab状态
            const currentTab = this.activeTab;
            await this.getCategoryList();
            // 恢复tab状态，确保不超出范围
            const tabIndex = parseInt(currentTab);
            if (this.categoryTabs.length > 0) {
              if (tabIndex >= this.categoryTabs.length) {
                // 如果当前tab索引超出范围，使用最后一个tab
                this.activeTab = (this.categoryTabs.length - 1).toString();
              } else {
                this.activeTab = currentTab;
              }
              this.filterTableData();
            }
          } catch (error) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 提交表单
    submitForm() {
      this.$refs.categoryForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.categoryForm.id) {
              // 编辑
              await this.$post(
                "/housekeepingCategory/update",
                this.categoryForm
              );
              this.$message.success("编辑成功");
            } else {
              // 新增
              await this.$post("/housekeepingCategory/add", this.categoryForm);
              this.$message.success("新增成功");
            }
            this.dialogVisible = false;
            // 保存当前tab状态
            const currentTab = this.activeTab;
            await this.getCategoryList();
            // 恢复tab状态
            this.activeTab = currentTab;
            this.filterTableData();
          } catch (error) {
            this.$message.error("操作失败");
          }
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.categoryForm.resetFields();
    },
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return "-";
      const date = new Date(timestamp);
      return date.toLocaleString("zh-CN");
    },
    // 格式化图片URL
    formatImageUrl(url) {
      if (!url) return "";
      if (url.indexOf("http") > -1) {
        return url;
      }
      return this.host + url;
    },
    // 上传横幅图片
    async handleBannerUpload(file, fileList) {
      var param = new FormData();
      param.append("file", file.raw);
      try {
        let data = await this.$upload("/File/upload", param);
        this.categoryForm.bannerImage = this.host + data;
      } catch (error) {
        this.$message.error("图片上传失败");
      }
    },
    // 删除横幅图片
    deleteBannerImage() {
      this.$confirm("确认删除该图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.categoryForm.bannerImage = "";
          this.$message.success("删除成功");
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.filterTableData();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.filterTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;

  .tabs-container {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 4px;
  }

  .search-box {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px 10px;
    border-radius: 4px;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 20px;
      width: 300px;
      margin-right: 10px;
    }
  }

  .table-container {
    flex: 1;
    overflow: auto;
  }

  .pages {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    text-align: right;
    height: 55px;
    box-sizing: border-box;
  }
}
</style>
